/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface FarmingBonusHistoryItem
 */
export interface FarmingBonusHistoryItem {
  /**
   *
   * @type {number}
   * @memberof FarmingBonusHistoryItem
   */
  timestamp?: number
  /**
   *
   * @type {number}
   * @memberof FarmingBonusHistoryItem
   */
  referralsFarmed?: number
  /**
   *
   * @type {number}
   * @memberof FarmingBonusHistoryItem
   */
  referralsReward?: number
  /**
   *
   * @type {number}
   * @memberof FarmingBonusHistoryItem
   */
  teamFarmed?: number
  /**
   *
   * @type {number}
   * @memberof FarmingBonusHistoryItem
   */
  teamReward?: number
}

export function FarmingBonusHistoryItemFromJSON(json: any): FarmingBonusHistoryItem {
  return FarmingBonusHistoryItemFromJSONTyped(json, false)
}

export function FarmingBonusHistoryItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): FarmingBonusHistoryItem {
  if (json === undefined || json === null) {
    return json
  }
  return {
    timestamp: !exists(json, 'timestamp') ? undefined : json['timestamp'],
    referralsFarmed: !exists(json, 'referralsFarmed') ? undefined : json['referralsFarmed'],
    referralsReward: !exists(json, 'referralsReward') ? undefined : json['referralsReward'],
    teamFarmed: !exists(json, 'teamFarmed') ? undefined : json['teamFarmed'],
    teamReward: !exists(json, 'teamReward') ? undefined : json['teamReward'],
  }
}

export function FarmingBonusHistoryItemToJSON(value?: FarmingBonusHistoryItem | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    timestamp: value.timestamp,
    referralsFarmed: value.referralsFarmed,
    referralsReward: value.referralsReward,
    teamFarmed: value.teamFarmed,
    teamReward: value.teamReward,
  }
}
